import { encodeFile } from './encodeFile';
export function objectUrlFileToBase64(objectUrl) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', objectUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      var file = xhr.response;
      resolve(encodeFile(file, {
        withoutMarker: true
      }));
    };
    xhr.onerror = function (error) {
      return reject(error);
    };
    xhr.send();
  });
}